// extracted by mini-css-extract-plugin
export default {"root":"MainBoxLayout_root__LzNjg","body":"MainBoxLayout_body__cKS+z","clickable":"MainBoxLayout_clickable__GZmJz","container":"MainBoxLayout_container__2Dw2u"};